export const nav = {
    permissao: 'deck.backlog:ver',
    section: 'Trabalho',
    title: 'Backlog',
    icon: 'list_alt',
    route: '/backlog',
    sequence: 3,
};

export default [
    {
        path: '/backlog',
        name: 'backlog',
        component: () => import('@/modules/quadro/pages/EscolherProjetoPage.vue'),
        props: { destino: 'backlog-projeto' },
        meta: { requiresAuth: true, permissao: 'deck.backlog:ver' },
    },
    {
        path: '/backlog/:projectKey',
        name: 'backlog-projeto',
        component: () => import('./pages/BacklogPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'deck.backlog:ver' },
    },
];
